

















import { Component, Vue, Prop } from "@/common";

@Component({})
export default class Hamburger extends Vue {
  @Prop() isActive!: boolean;

  @Prop() toggleClick!: () => void;
}
